<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col">
        <h2>Convocation pour l'Assemblée Générale</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        Rappel des coordonnées de l'organisateur :
      </div>
      <div class="col-7">
        <img
          v-if="qrCodeBase64Image"
          class="position-absolute"
          :src="qrCodeBase64Image"
          alt="QR CODE"
          style="right: 0;"
        />
      </div>
    </div>
    <div class="row mb-3">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="col-5 font-italic"
        style="white-space: pre-line;"
        v-html="pdfContactDetails"
      ></div>
      <div class="col-7">
        <div style="margin-top: 80px; margin-left: 50px;">
          <span v-if="addresses.line1">{{ addresses.line1 }} <br /></span>
          <span v-if="addresses.line2">{{ addresses.line2 }} <br /></span>
          <span v-if="addresses.line3">{{ addresses.line3 }} <br /></span>
          <span v-if="addresses.line4">{{ addresses.line4 }} <br /></span>
          <span v-if="addresses.line5">{{ addresses.line5 }} <br /></span>
          <span v-if="addresses.line6">{{ addresses.line6 }} <br /></span>
          <span v-if="addresses.line7">{{ addresses.line7 }}</span>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col">
        Copropriété : {{ building.name }}
        <div class="text-br-line font-italic">{{ building.address }}</div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div style="margin-top: 100px;">
          Madame, Monsieur, <br />
          Conformément à la loi du 10 Juillet 1965 (modifiée par la loi du 31/12/1985 et le décret
          du 09/06/1986) et au règlement de copropriété, nous vous invitons à participer à
          l'Assemblée Générale de votre copropriété qui se tiendra,
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div
        v-if="meeting.allowed_modalities.physical || meeting.allowed_modalities.video"
        class="col text-center font-weight-bold"
      >
        {{
          $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY [à] HH[h]mm")
        }}
      </div>
      <div v-else class="col text-center font-weight-bold">
        {{ $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY") }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col text-center">
        <span v-if="meeting.allowed_modalities.physical">
          à l'adresse suivante :
          <!-- eslint-disable-next-line prettier/prettier -->
          <div v-if="meeting.address" class="text-br-line font-weight-bold mb-3" v-html="meeting.address"></div>
          <div v-else class="text-danger">pas d'adresse définie</div>
        </span>
        <div v-if="meeting.access">
          Modalités d'accès :
          <div class="text-br-line font-weight-bold" v-html="meeting.access"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        selon les modalités suivantes :
        <ul>
          <li v-if="meeting.allowed_modalities.physical">
            Présence physique à l'adresse mentionnée ci-dessus.
          </li>
          <!-- REVIEW: Uncomment this in v2 -->
          <li v-if="meeting.allowed_modalities.correspondence">
            Vote par correspondance à partir du formulaire joint.
          </li>
          <li v-if="meeting.allowed_modalities.video">
            Visioconférence
            <span v-if="!meeting.external_video_solution">à partir du votre espace personnel.</span>
            <span v-else>{{ " " + meeting.external_video_solution }}</span>
            <br />
          </li>
        </ul>
      </div>
    </div>
    <div v-if="meeting.allowed_modalities.video && meeting.show_connection_details" class="row">
      <!-- Hide credentials when is generated for one mandate only - TASK DEV-4017-->
      <div v-if="!isForOneMandate" class="col">
        Pour accéder à votre espace personnel:
        <!-- REVIEW: Uncomment this in v2 -->
        <!-- transmettre votre pouvoir, -->
        <!-- <span v-if="meeting.allowed_modalities.correspondence">par correspondance</span> -->
        <!-- <span v-if="meeting.allowed_modalities.correspondence && meeting.allowed_modalities.video">
          ou
        </span> -->
        <span v-if="meeting.allowed_modalities.video">par visioconférence</span> :

        <div class="row">
          <div class="col-3">
            <span class="ml-3">lien de connexion :</span>
          </div>
          <div class="col-9">
            <a class="text-dark" href="https://participant.domeo-ag.com">
              https://participant.domeo-ag.com
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <span class="ml-3">identifiant :</span>
          </div>
          <div class="col-9">
            <span class="text-monospace">{{ mandate.building_owner.username }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <span class="ml-3">mot de passe :</span>
          </div>
          <div class="col-9">
            <span>
              <span v-if="mandate.building_owner.password" class="text-monospace">
                {{ mandate.building_owner.password }}
              </span>
              <span v-else>
                merci d'utiliser votre mot passe que vous avez défini <br />
                (au cas où vous ne vous souvenez pas de votre mot de passe vous pouvez utiliser la
                fonctionnalité de mot de passe oublié pour réinitialiser votre mot de passe)
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col">
        Vous trouverez ci-joint :
        <ul>
          <li v-if="!meeting.allowed_modalities.correspondence">
            Le pouvoir pour être représenté.
          </li>
          <li v-if="meeting.allowed_modalities.correspondence">
            Le formulaire de vote par correspondance.
          </li>
          <li>
            L'ordre du jour de cette Assemblée.
          </li>
          <li v-if="extractParentResolutionsWithChildren().length > 0">
            Les documents suivants qui aideront à la compréhension des résolutions :
            <ul>
              <li
                v-for="(resolution, i) in extractParentResolutionsWithChildren()"
                :key="`resolution-${i}`"
                class="no-break"
              >
                Résolution n° {{ resolution.position }}
                <ul>
                  <li v-for="(media, j) in resolution.media" :key="`media-${i}-${j}`">
                    <span v-if="media.label" class="font-italic">{{ media.label }}</span>
                    <span v-else class="font-italic">{{ media.filename }}</span>
                  </li>
                  <li
                    v-for="(childrenResolution, childrenIndex) in resolution.children_resolutions"
                    :key="`resolution-children-${childrenIndex}`"
                    class="no-break"
                    style="list-style-type: circle;"
                  >
                    Sous résolution n° {{ resolution.position }}.{{ childrenResolution.position }}
                    <ul>
                      <li
                        v-for="(media, childMediaIndex) in childrenResolution.media"
                        :key="`media-${childrenIndex}-${childMediaIndex}`"
                      >
                        <span v-if="media.label" class="font-italic">{{ media.label }}</span>
                        <span v-else class="font-italic">{{ media.filename }}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mt-5 no-break">
      <div class="col">
        <!-- Don't display when only allowed_modalities.correspondance is true -->
        <div
          v-if="meeting.allowed_modalities.physical || meeting.allowed_modalities.video"
          class="row"
        >
          <div class="col">
            Au cas où vous ne pourriez pas assister à la présente Assemblée Générale, nous vous
            serions reconnaissants de bien vouloir utiliser le pouvoir joint, au nom d'un mandataire
            de votre choix. Le syndic ne peut accepter de procuration.
          </div>
        </div>
        <div class="row">
          <div class="col mt-5">
            Nous vous prions d'agréer, Madame, Monsieur, l'expression de nos sincères salutations.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "meeting",
    "building",
    "resolutions",
    "mandate",
    "countries",
    "pdfContactDetails",
    "isForOneMandate",
    "qrCodeBase64Image",
  ],
  data() {
    return {
      addresses: {},
      resolutionsWithMedia: [],
    };
  },
  created() {
    this.extractAddresses();
  },
  methods: {
    extractAddresses() {
      var line1 = this.getPersonName({}, this.mandate.building_owner);
      // TODO: Refactor this code
      // This could be handeled in some method to get out correct address
      var line2 = this.mandate.building_owner.complement;
      var line3 = this.mandate.building_owner.complement2;
      var line4 = this.mandate.building_owner.address;
      var line5 = "";
      var line6 = "";
      var line7 = "";
      let countryNotToShow = "FRANCE FR France Fr fr france";
      if (this.mandate.building_owner.zipcode) {
        line6 += this.mandate.building_owner.zipcode;
      }
      if (this.mandate.building_owner.city) {
        line6 += " " + this.mandate.building_owner.city;
      }
      if (
        this.mandate.building_owner.country &&
        !countryNotToShow.includes(this.mandate.building_owner.country)
      ) {
        line7 = this.getCountryName(this.mandate.building_owner.country);
      }
      this.addresses = {
        line1,
        line2,
        line3,
        line4,
        line5,
        line6,
        line7,
      };
    },
    extractParentResolutionsWithChildren() {
      let parentResolutions = [];
      this.resolutions.forEach(resolution => {
        if (resolution.parent_resolution_id != null) {
          return;
        }
        let childrenResolutions = this.extractChildrenResolutionWithMedia(
          resolution.children_resolutions
        );
        let sortedMedia = this.$_.sortBy(resolution.media, item => {
          return item.position;
        });
        let sortedChildrenWithMedia = this.$_.sortBy(childrenResolutions, item => {
          return item.position;
        });
        resolution.media = sortedMedia;
        resolution.children_resolutions = sortedChildrenWithMedia;
        if (resolution.media.length > 0 || resolution.children_resolutions.length > 0) {
          parentResolutions.push(resolution);
        }
      });
      return parentResolutions;
    },
    extractChildrenResolutionWithMedia(childrenResolutions) {
      let childrenResolutionsWithMedia = [];
      childrenResolutions.forEach(chResolution => {
        if (chResolution.media.length == 0) {
          return;
        }
        let sortedMedia = this.$_.sortBy(chResolution.media, item => {
          return item.position;
        });
        chResolution.media = sortedMedia;
        childrenResolutionsWithMedia.push(chResolution);
      });
      return childrenResolutionsWithMedia;
    },
    getCountryName(countryCode) {
      let foundCountry = this.$_.find(this.countries, country => {
        return country.countryCode == countryCode.toUpperCase();
      });
      if (foundCountry) {
        return foundCountry.countryName;
      } else {
        return "";
      }
    },
  },
};
</script>
